import React from 'react';
import { Link } from 'react-router-dom';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/oqC6NEx92Q4z8Tiwayznuu/Imagen_de_ChatGPT_28_sept_2026,_16_19_17-Photoroom.png';
export function Logo() {
  return <Link to="/" className="inline-flex items-center rounded-lg bg-ink px-2.5 py-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" aria-label="Tracker Group LLC home" data-id="element-147" data-mp="3qamch4a5rr4m">
      <img src={LOGO_URL} alt="Tracker Group LLC" className="h-9 w-auto" data-id="element-148" data-mp="mqromp86ujts" />
    </Link>;
}